import { Scale } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const ScaleIcon = createLucideIcon(Scale);
